import React, {useState, useEffect} from "react";
import {connect, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {setCurrentCompanySession} from "../../../../store/actions/session";
import {fetchCompany} from "../../../../api/companies";
import {CompanySelect, OfficeSelect} from "../../../../app/_elements/form";

const allOfficesOption = {label: '-- All Offices --', value: "", id: "0", office_name: '-- All Offices --'};

const SettingsPanelForm = ({currentCompany, currentOffice, allCompanies, setCurrentCompanySession}) => {
    const companies = useSelector(state => state.session.companies);
    const [saving, setSaving] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState(currentCompany);
    const [selectedOffice, setSelectedOffice] = useState(currentOffice);
    const [allCompaniesCheck, setAllCompaniesCheck] = useState(allCompanies);

    const handleCompanyChange = (company) => {
        setSelectedCompany(company);
    }
    const handleOfficeChange = (office) => {
        setSelectedOffice(office);
    }
    const handleAllCompaniesChange = (event) => {
        setAllCompaniesCheck(event.target.checked);
    }
    const handleSubmit = (event) => {
        event.preventDefault();
        setSaving(true);

        fetchCompany(selectedCompany.id).then(({data}) => {
            setCurrentCompanySession(data.data, selectedOffice, allCompaniesCheck);

            toast.success(`Company changes saved !`);

            setSaving(false);
        }).catch(() => {
            setSaving(false);
        });
    }

    useEffect(() => {
        function resetOffice() {
            if (currentCompany.id !== selectedCompany.id) {
                setSelectedOffice(allOfficesOption);
            }
        }

        resetOffice();
    }, [selectedCompany]);

    return (
        <form action="" onSubmit={handleSubmit}>
            <div className="form-group mb-4">
                <label className="font-weight-bolder" htmlFor="exampleSelects">Company</label>
                <CompanySelect
                    options={companies}
                    defaultValue={selectedCompany}
                    onChange={handleCompanyChange}
                />
            </div>

            <div className="form-group mb-6">
                <label className="font-weight-bolder" htmlFor="exampleSelects">Office</label>
                <OfficeSelect
                    selectedCompany={selectedCompany}
                    currentValue={selectedOffice}
                    onChange={handleOfficeChange}
                    allOfficesOption={allOfficesOption}
                />
            </div>

            <div className="d-flex flex-center justify-content-between">
                <div className="checkbox-inline">
                    <label className="checkbox m-0">
                        <input type="checkbox"
                               name="check_all_companies"
                               onChange={handleAllCompaniesChange}
                               checked={allCompaniesCheck}/>
                        <span></span>
                        All companies
                    </label>
                </div>

                <button className="btn btn-secondary px-9 waves-effect waves-light" disabled={saving}>
                    Save changes
                    {saving && <span className="ml-3 spinner spinner-white"></span>}
                </button>
            </div>
        </form>
    );
}

const mapStateToProps = (state) => {
    return {
        currentCompany: state.session.current_company,
        currentOffice: state.session.current_office,
        allCompanies: state.session.all_companies,
    };
}

export default connect(mapStateToProps, {setCurrentCompanySession})(SettingsPanelForm);
